 import Vue from 'vue'
import VueRouter from 'vue-router'
// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'


import authentication from './routes/authentication'
import marketing from './routes/marketing'
import lead from './routes/sale/lead'
import service from './routes/sale/service'
import customer from './routes/sale/customer'
import warehouse from './routes/warehouse'
import labour from './routes/inventory/labour'
import jobcard from './routes/production/jobcard'
import monitoring from './routes/production/monitoring'
import chartofaccounts from './routes/accounting/chartofaccounts'
import taxsetup from './routes/accounting/taxsetup'
import journalentry from './routes/accounting/journalentry'
import trialbalance from './routes/accounting/trialbalance'
import assets from './routes/accounting/assets'
import bank from './routes/accounting/bank'
import budget from './routes/accounting/budget'
import metrics from './routes/accounting/metrics'
import income from './routes/accounting/income'
import expenses from './routes/accounting/expenses'
import reconciliation from './routes/accounting/reconciliation'
import role from './routes/role'
import equipment from './routes/inventory/equipment'
import project from './routes/projectmanagement/project'
import supplier from './routes/supplier'
import category from './routes/category'
import quotation from './routes/sale/quotation.js'
import salesorder from './routes/sale/salesorder.js'
import dashboard from './routes/dashboard'
import invoices from './routes/invoices'
import products from './routes/product'
import support from './routes/support'
import reports from './routes/reports'
import accountingreports from './routes/reports/accountingreports'
import purchaseorder from './routes/inventory/purchaseorder.js'
import purchaseinvoice from './routes/inventory/purchaseinvoice.js'
import inventoryTransactions from './routes/inventory/inventoryTransactions'
import lowstock from './routes/inventory/lowstock.js'
import opportunity from './routes/sale/opportunity'
import complaint from './routes/sale/complaint'
import pipeline from './routes/sale/pipeline'
import marketingleads from './routes/marketingleads'
import email from './routes/email'
import leave from './routes/hrmanagement/hr'
import workForceTracking from './routes/hrmanagement/hr'
import delivery from './routes/delivery/delivery'
import PayrollListing from './routes/hrmanagement/hr'
import AddAllocation from './routes/hrmanagement/hr'
import Landing from './routes/landing.js'
import batchProduction from './routes/production/batchproduction'
import ecommerce from './routes/ecommerce.js'
import Websitebuilder from './routes/websitebuilder'
import Elearning from './routes/elearning'
import bitoolsreport from './routes/bitoolsreport'

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'landing1' } },
    ...authentication,
    ...salesorder,
    ...warehouse,
    ...marketing,
    ...lead,
    ...service,
    ...labour,
    ...customer,
    ...role,
    ...jobcard,
    ...monitoring,
    ...chartofaccounts,
    ...taxsetup,
    ...journalentry,
    ...trialbalance,
    ...assets,
    ...bank,
    ...budget,
    ...metrics,
    ...supplier,
    ...category,
    ...quotation,
    ...purchaseorder,
    ...dashboard,
    ...opportunity,
    ...complaint,
    ...invoices,
    ...products,
    ...reports,
    ...accountingreports,
    ...support,
    ...equipment,
    ...inventoryTransactions,
    ...lowstock,
    ...pipeline,
    ...marketingleads,
    ...email,
    ...project,
    ...leave,
    ...workForceTracking,
    ...delivery,
    ...PayrollListing,
    ...AddAllocation,
    ...Landing,
    ...purchaseinvoice,
    ...batchProduction,
    ...Websitebuilder,
    ...income,
    ...expenses,
    ...reconciliation,
    ...ecommerce,
    ...Elearning,
    ...bitoolsreport,
 
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  
  if (!canNavigate(to)) {
    if (!isLoggedIn) return next({ name: 'auth-login' })

    return next({ name: 'misc-not-authorized' })
  }
  if (to.meta.permission) {
    const userData = localStorage.getItem('userData')
    const permissions = JSON.parse(userData).permissions

    if (!permissions.includes(to.meta.permission)) {
      console.log("🚀 ~ file: index.js:141 ~ router.beforeEach ~ permissions:", !permissions.includes(to.meta.permission))
      return next({ name: 'misc-not-authorized' })
    }
  }


  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  if(to.name == 'subtasks-list'){
    to.meta.breadcrumb[0].to = `/projectmanagement/tasks-list/${to.params.id}`;
  }

  return next()
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
